import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FileUploadService {
    baseUrl = environment.apiUrl;

    response: any;

    constructor(private http: HttpClient) { }

    uploadCV(image: File): Observable<any> {
      const date = new Date();
      const newName = date.getTime() + '_' + this.stringToUrl(image.name);
      Object.defineProperty(image, 'name', {
        writable: true,
        value: newName
      });
      const formData = new FormData();
      formData.append('cv', image);

      const params = new HttpParams().set('name', newName);
      return this.http.post(`${this.baseUrl}/uploadFile`, formData, {params: params})
        .pipe(map((res) => {
          this.response = res['data'];
          return this.response;
        }),
        catchError(this.handleError));
    }

    stringToUrl(name: string) {
      let url = name.toLowerCase();
      // we simplify character because accent are forbidden
      url = url.replace(/[àáåâãæä]/g, 'a');
      url = url.replace(/[ç]/g, 'c');
      url = url.replace(/[ð]/g, 'd');
      url = url.replace(/[éêèë€]/g, 'e');
      url = url.replace(/[ïìíî]/g, 'i');
      url = url.replace(/[öôóòœõø]/g, 'o');
      url = url.replace(/[ñ]/g, 'n');
      url = url.replace(/[$]/g, 's');
      url = url.replace(/[úùûü]/g, 'u');
      url = url.replace(/[ÿý]/g, 'y');
      // we remove each character which is not alpha-numeric, underscore, space, point
      url = url.replace(/[^a-z0-9_. ]/g, '');
      // we remove multi spaces
      url = url.replace(/\s\s+/g, ' ');
      // we set '-' instead of spaces to have a url friendly string
      url = url.replace(/[ ]/g, '-');
      return url;
    }

    private handleError(error: HttpErrorResponse) {
        console.log(error);
        // return an observable with a user friendly message
        return throwError('Error! something went wrong.');
    }
}
